<template>
	<v-divider role="presentation" />
</template>

<script>
export default {
	name: 'KDivider'
};
</script>